
export const logError = (msg: string,err: any) => {//NOSONAR
  console.log(msg, err); //NOSONAR
}
